var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44352 8.73786C5.71879 8.83666 2.70838 9.87423 0.514615 12.8881C0.361574 13.1351 -0.0466344 12.9375 0.00438174 12.6411C1.12688 7.40399 4.49447 3.20431 9.44369 3.35258V0.289202C9.44369 0.042196 9.74986 -0.106077 9.9029 0.0916064L15.9235 5.87217C16.0255 5.97096 16.0255 6.16864 15.9235 6.26745L9.9029 12.0974C9.74986 12.2456 9.44369 12.1468 9.44369 11.8998L9.44352 8.73786Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareArrow);
export default __webpack_public_path__ + "static/media/share-arrow.239bf2c447aa56c829f5c49a32f4cd1a.svg";
export { ForwardRef as ReactComponent };